<ng-container [ngSwitch]="type">
	<ng-container *ngSwitchCase="types.radio">
		<form-radio-list
			class="p-0 form-element"
			[attr.id]="'selector-'+field.templateField.templateFieldId"
			[control]="field.fieldFormGroup.get('content.selected')"
			[label]="field.templateField.name"
			[template]="ControlTemplate.vertical"
			[options]="field.templateField.body.options"
			[setWarnings]="{
			deprecated: field.templateField.deprecated,
			wasWarning: wasWarning
			}"
			[warningOption]="field.templateField.body?.warningOption"
			[variant]="field.templateField.body.variant">
		</form-radio-list>
		<ng-container *ngIf="(field.fieldFormGroup.get('content.selected').value && otherPlaceholders && field.templateField.body.otherOptions?.length) &&
		field.templateField.body.otherOptions.includes(field.fieldFormGroup.get('content.selected').value)">
			<form-richtext
				class="d-block c-mt-1"
				[placeholder]="otherPlaceholders[field.fieldFormGroup.get('content.selected').value] + ':'"
				[control]="field.fieldFormGroup.get('content.selectedDescription')"
				[label]="otherPlaceholders[field.fieldFormGroup.get('content.selected').value]"
				[templateFieldId]="templateFieldId"
				[template]="ControlTemplate.vertical">
			</form-richtext>
		</ng-container>
	</ng-container>
	<ng-container  *ngSwitchCase="types.checkbox">
		<form-checkbox-list
			class="p-0 form-element"
			[attr.id]="'selector-'+field.templateField.templateFieldId"
			[control]="field.fieldFormGroup.get('content.selected')"
			[label]="field.templateField.name"
			[template]="ControlTemplate.vertical"
			[options]="field.templateField.body.options"
			[setWarnings]="{deprecated: field.templateField.deprecated}"
			[variant]="field.templateField.body.variant">
		</form-checkbox-list>
		<ng-container *ngFor="let option of field.templateField.body.otherOptions, let index = index">
			<ng-container *ngIf="(option && otherPlaceholders && field.templateField.body.otherOptions?.length) &&
			field.fieldFormGroup.get('content.selected').value?.includes(option)">
				<form-richtext
					class="c-mt-1 d-block"
					[attr.id]="'selector-'+field.templateField.templateFieldId"
					[placeholder]="otherPlaceholders[option] + ':'"
					[control]="selectedDescriptionArray.at(index).get('description')"
					[label]="otherPlaceholders[option]"
					[templateFieldId]="templateFieldId"
					[template]="ControlTemplate.vertical">
				</form-richtext>
			</ng-container>
		</ng-container>
	</ng-container>
	<ng-container *ngSwitchCase="types.select">
		<form-select
			class="p-0 form-element"
			[attr.id]="'selector-'+field.templateField.templateFieldId"
			[control]="field.fieldFormGroup.get('content.selected')"
			[label]="field.templateField.name"
			[options]="field.templateField.body.options"
			[template]="ControlTemplate.horizontal"
			[placeholder]="field.templateField.body.placeholder"
			[setWarnings]="{deprecated: field.templateField.deprecated}">
		</form-select>
		<ng-container *ngIf="(field.fieldFormGroup.get('content.selected').value && otherPlaceholders && field.templateField.body.otherOptions?.length) &&
		field.templateField.body.otherOptions.includes(field.fieldFormGroup.get('content.selected').value)">
			<form-richtext
				class="d-block c-mt-1"
				[placeholder]="otherPlaceholders[field.fieldFormGroup.get('content.selected').value] + ':'"
				[control]="field.fieldFormGroup.get('content.selectedDescription')"
				[label]="otherPlaceholders[field.fieldFormGroup.get('content.selected').value]"
				[templateFieldId]="templateFieldId"
				[template]="ControlTemplate.vertical">
			</form-richtext>
		</ng-container>
	</ng-container>
	<ng-container *ngSwitchCase="types.multiselect">
		<form-select
			class="p-0 form-element"
			[attr.id]="'selector-'+field.templateField.templateFieldId"
			[multiple]="true"
			[control]="field.fieldFormGroup.get('content.selected')"
			[label]="field.templateField.name"
			[options]="field.templateField.body.options"
			[template]="ControlTemplate.horizontal"
			[placeholder]="field.templateField.body.placeholder"
			[setWarnings]="{deprecated: field.templateField.deprecated}">
		</form-select>
		<ng-container *ngFor="let option of field.templateField.body.otherOptions, let index = index">
			<ng-container *ngIf="(option && otherPlaceholders && field.templateField.body.otherOptions?.length) &&
			selectedFlattened?.includes(option)">
				<form-richtext
					class="c-mt-1 d-block"
					[attr.id]="'selector-'+field.templateField.templateFieldId"
					[placeholder]="otherPlaceholders[option] + ':'"
					[control]="selectedDescriptionArray.at(index).get('description')"
					[label]="otherPlaceholders[option]"
					[templateFieldId]="templateFieldId"
					[template]="ControlTemplate.vertical">
				</form-richtext>
			</ng-container>
		</ng-container>
	</ng-container>
</ng-container>
